/**
 * The version the staff see at the foot of the sidebar.
 *
 * Christian, 30 October 2026: a version number under the signed-in user, so a
 * person who reports a fault can say which release they had. It is the release
 * the deploy stamps on the build (`scripts/deploy.sh`), the same value every
 * fault report carries (`src/lib/sentry.ts`), so the number somebody reads out
 * finds the release in the logs. One source: there is no second version to
 * keep in step.
 */
export const RELEASE = process.env.PUBLIC_SENTRY_RELEASE ?? 'obsessed-web@dev';

/**
 * `obsessed-web@20261030-123456` as `2026.10.30-1234`: the date and the time of
 * the deploy, in an order that sorts. Null for a build the deploy did not
 * stamp, which is a laptop or a test.
 */
export function versionLabel(release: string = RELEASE): string | null {
  const m = /@(\d{4})(\d{2})(\d{2})-(\d{2})(\d{2})\d{2}$/.exec(release);
  return m ? `${m[1]}.${m[2]}.${m[3]}-${m[4]}${m[5]}` : null;
}
